export const lpComponentTypes = {
  HERO: "hero-component",
  FEATURE: "feature",
  FEATURE_GRID: "feature-grid",
  SECTION_TITLE: "section-title",
};
